import React from 'react';
import classNames from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import { VideoIcon } from '@fiverr-private/icons';
import { Consultation } from '@fiverr-private/consultation';
import { Button, Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { theme } from '@fiverr-private/theme';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { PAGE_NAME } from '../../../monitoring';
import styles from './index.module.scss';

export const ConsultationButton = () => {
    const { userId } = getContext();

    const { consultationData, currency, seller } = useFreelancerPageContext();

    const { id, name: sellerName, profileImageUrl } = seller?.user || {};
    const sellerId = Number(id);

    const biEnrichment = {
        pageName: PAGE_NAME,
        elementName: 'consultation_button',
        group: PAGE_NAME,
        seller: { id: sellerId },
        user: { id: userId },
    };

    const consultationMixpanelEnrichment = {
        'Seller Name': sellerName,
        Origin: PAGE_NAME,
        'Page Name': PAGE_NAME,
    };

    const learnMoreLink = pathfinder(
        'help_center_article',
        { article_id: 12744510059665 },
        { query: { segment: 'buyer' } }
    );

    return (
        <Consultation
            consultationData={consultationData}
            sellerId={sellerId}
            sellerName={sellerName}
            profilePhoto={profileImageUrl}
            biEnrichment={biEnrichment}
            mixpanelEnrichment={consultationMixpanelEnrichment}
            learnMoreLink={learnMoreLink}
            currency={currency}
            className={classNames(styles.consultationContainer, 'm-b-16')}
        >
            <Button fill="ghost" className={styles.consultationBtn} color="light-grey">
                <>
                    <Icon className={styles.icon}>
                        <VideoIcon color={theme.greyColors.grey_1200} />
                    </Icon>
                    <I18n k="freelancer_page.consultation.button_cta" />
                </>
            </Button>
        </Consultation>
    );
};
